import { JackpotDisplayType, Settings } from "./Settings";
import { JackpotLevel } from "./api";

export type JackpotProperties = Record<JackpotLevel, JackpotPropertiesLevel>;

export interface JackpotPropertiesLevel {
    name: string;
    color: string;
}

export const JackpotShowtimeDuration: Readonly<Record<JackpotLevel, number>> = {
    [JackpotLevel.Jp4]: 42000,
    [JackpotLevel.Jp4s]: 42000,
    [JackpotLevel.Jp3]: 29000,
    [JackpotLevel.Jp3s]: 29000,
    [JackpotLevel.Jp2]: 23000,
    [JackpotLevel.Jp1]: 19000,
}

export const JackpotProperties: Readonly<Record<JackpotDisplayType, Readonly<JackpotProperties>>> = {
    [JackpotDisplayType.PreciousSpin]: null,
    [JackpotDisplayType.DiamondPot]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotOrtiz]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotStep]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DragonJackpot]: {
        [JackpotLevel.Jp4]: { name: "DRAGON", color: "YELLOW" },
        [JackpotLevel.Jp4s]: { name: "DRAGON shared", color: "YELLOW" },
        [JackpotLevel.Jp3]: { name: "GRAND", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "GRAND shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "#05DBF2" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "#50F205" },
    },
    [JackpotDisplayType.DiamondPotJubilee]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotCaliente]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotPlayCity]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.JubileeLink]: {
        [JackpotLevel.Jp4]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp4s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp3]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp3s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.ViventoLink]: {
        [JackpotLevel.Jp4]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp4s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp3]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp3s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.RapidDiamondPot]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.RapidDiamondPot2]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.RapidDiamondPotStep]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.PaytableJackpotDisplay]: null,
    [JackpotDisplayType.RapidDiamondPotFire]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.PlayCityLink]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.DiamondPotRappidFrames]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.RapidDiamondPotStep2]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },

    [JackpotDisplayType.RainbowGirls]: {
        [JackpotLevel.Jp4]: { name: "MEGA", color: "#FF00FF" },
        [JackpotLevel.Jp4s]: { name: "MEGA shared", color: "#FF00FF" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "#FF0000" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "#FF0000" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "#00FF00" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "#0000FF" },
    },

    [JackpotDisplayType.DiamondPotStepRappidFrames]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },

    [JackpotDisplayType.DiamondPotStepShared]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotStepSharedSpineV2]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotStepSinShared]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotStepSinSharedSpineV2]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotStepRappidFramesSpine]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotRappidFramesSpine]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.PlayCityLinkResponsive]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.JubileeLinkResponsive]: {
        [JackpotLevel.Jp4]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp4s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp3]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp3s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotResponsive]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" }
    },
    [JackpotDisplayType.PlayCityLinkResponsivePIXI]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: undefined, //{ name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: undefined, //{ name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.JubileeLinkResponsivePIXI]: {
        [JackpotLevel.Jp4]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp4s]: undefined, //{ name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp3]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp3s]: undefined, //{ name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotResponsivePIXI]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: undefined, //{ name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: undefined, //{ name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05447a" /*color: "#05DBF2"*/ }
    },
    [JackpotDisplayType.DiamondPotPyramidShared]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotPyramidSinShared]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotPyramidJP4ShareJP3SinShared]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotPyramidShared2S]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotPyramidSinShared2S]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotResponsivePIXIHorizontal]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotPyramidSinSharedResponsive]: {
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.JubileeLinkResponsivePIXIAPPHorizontal]: {
        [JackpotLevel.Jp4]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp4s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp3]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp3s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.JackpotDisplayPlayCityPIXIAPPHorizontal]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.JackpotDisplayRapidLinkPIXIAPPHorizontal]: {
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: {name: undefined, color: undefined}, // { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: {name: undefined, color: undefined}, // { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2"},
    }
};
